import { create } from "apisauce";
import axios from "axios";
import { buildStorage, setupCache } from "axios-cache-interceptor";
import localforage from "localforage";

import Config from "config";
import { legacyParamsSerializer } from "./_paramsSerializer";

// Create `localforage` instance
export const forageStore = localforage.createInstance({
  driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE],
  name: `${Config.apiDomain}|query|CBH-CMS`,
});

// Non memory cache
// Memory cache is handled by react-query
const storage = buildStorage({
  find: async (key) => (await forageStore.getItem(key)) ?? undefined,
  set: async (key, value) => {
    await forageStore.setItem(key, value);
  },
  remove: (key) => forageStore.removeItem(key),
  clear: () => forageStore.clear(),
});

// Backwards-compatible alias for the persistent store
export const apiStore = forageStore as LocalForage;

// Trigger to clear cache
export const clearCache = async () => {
  await apiStore.clear();
};

// Prepare apisauce requestor instance
const getRequestorInstance = () => {
  const cachedAxiosInstance = setupCache(
    axios.create({
      baseURL: Config.apiDomain,
      paramsSerializer: legacyParamsSerializer,
    }),
    {
      storage,
      ttl: parseInt(process.env.REACT_APP_API_CACHE_AGE as string, 10),
      // Preserve previous axios-cache-adapter behaviour:
      // cache every method and ignore server cache headers
      interpretHeader: false,
      methods: ["get", "post", "patch", "put", "delete"],
    }
  );

  //@ts-ignore
  const apisauceInstance = create({ axiosInstance: cachedAxiosInstance });

  return apisauceInstance;
};

const requestor = getRequestorInstance();

export const getTypedRequestor = (type) => {
  return requestor[type];
};
